/**
 * Jertscript Token Types
 *
 * "Honestly, TypeScript could use more croissants." 🥐
 */

export enum TokenType {
  // Keywords - Variables
  CROISSANT = 'CROISSANT',     // const
  BAGUETTE = 'BAGUETTE',       // let

  // Keywords - Literals
  OUI = 'OUI',                 // true
  NON = 'NON',                 // false
  RIEN = 'RIEN',               // null

  // Keywords - Functions
  FONCTION = 'FONCTION',       // function
  RETOURNER = 'RETOURNER',     // return

  // Keywords - Control Flow
  FRANCHEMENT = 'FRANCHEMENT', // if
  SINON = 'SINON',             // else

  // Keywords - Loops
  PENDANT = 'PENDANT',         // while
  POUR = 'POUR',               // for
  CASSER = 'CASSER',           // break
  CONTINUER = 'CONTINUER',     // continue

  // Keywords - Error Handling
  MALHEUREUSEMENT = 'MALHEUREUSEMENT', // try
  MERDE = 'MERDE',             // catch
  QUANDMEME = 'QUANDMEME',     // finally
  LANCER = 'LANCER',           // throw

  // Keywords - OOP
  CLASSE = 'CLASSE',           // class
  NOUVEAU = 'NOUVEAU',         // new
  CECI = 'CECI',               // this

  // Keywords - Async
  ATTENDRE = 'ATTENDRE',       // await
  ASYNCHRONE = 'ASYNCHRONE',   // async

  // Keywords - Modules
  IMPORTER = 'IMPORTER',       // import
  EXPORTER = 'EXPORTER',       // export
  DE = 'DE',                   // from

  // Operators - Logical
  ET = 'ET',                   // &&
  OU = 'OU',                   // ||
  PAS = 'PAS',                 // !
  EST = 'EST',                 // ===
  NEST_PAS = 'NEST_PAS',       // !==

  // Operators - Arithmetic
  PLUS = 'PLUS',               // +
  MINUS = 'MINUS',             // -
  STAR = 'STAR',               // *
  SLASH = 'SLASH',             // /

  // Operators - Comparison
  LESS = 'LESS',               // <
  GREATER = 'GREATER',         // >
  LESS_EQUAL = 'LESS_EQUAL',   // <=
  GREATER_EQUAL = 'GREATER_EQUAL', // >=
  EQUAL = 'EQUAL',             // =
  EQUAL_EQUAL = 'EQUAL_EQUAL', // ==

  // Punctuation
  LPAREN = 'LPAREN',           // (
  RPAREN = 'RPAREN',           // )
  LBRACE = 'LBRACE',           // {
  RBRACE = 'RBRACE',           // }
  LBRACKET = 'LBRACKET',       // [
  RBRACKET = 'RBRACKET',       // ]
  COMMA = 'COMMA',             // ,
  DOT = 'DOT',                 // .
  SEMICOLON = 'SEMICOLON',     // ;
  COLON = 'COLON',             // :

  // Literals
  IDENTIFIER = 'IDENTIFIER',
  NUMBER = 'NUMBER',
  STRING = 'STRING',

  // End of file
  EOF = 'EOF',
}

/**
 * Token interface representing a single token in Jertscript
 */
export interface Token {
  /** The type of the token */
  type: TokenType;
  /** The original text that was matched */
  lexeme: string;
  /** The literal value (for numbers, strings, etc.) */
  literal: string | number | boolean | null;
  /** The line number where this token appears */
  line: number;
}

/**
 * Creates a new Token
 */
export function createToken(
  type: TokenType,
  lexeme: string,
  literal: string | number | boolean | null,
  line: number
): Token {
  return { type, lexeme, literal, line };
}
